export default __webpack_public_path__ + "static/media/June2020.5e8cc8be.png";